<!-- v1 - in use -->

<template>
    <div id="homeFeaturedProductsAB">
        <VueSlickCarousel v-bind="settings">
            <div v-for="product in productBlocks">
                <a :href="product.url" class="main-image">
                    <div v-if="tagExists('new', product.tags)" class="tag tag-new">New</div><!-- tag -->
                    <div v-if="tagExists('Final Sale', product.tags)" class="tag tag-final-sale">Final Sale</div><!-- tag -->
                    <div v-if="tagExists('Sale', product.tags)" class="tag tag-sale">Sale</div><!-- tag -->
                    <img :src="product.imgMd" :data-src="imgSrc" draggable="false" :id="'prod'+ product.id" class="img-responsive" />
                </a> 
                <div class="row">
                    <div class="col-8 col-xl-9">
                        <a :href="product.url"><h6>{{ product.title }}</h6></a>
                    </div><!-- .col -->
                    <div class="col-4 col-xl-3 text-right">
                        <h6>{{ formatPrice(product.compare_at_price) }}</h6>
                    </div><!-- .col -->
                </div><!-- .row -->
                <div class="yotpo bottomLine" 
				data-appkey="oqN68L8QxaUkj7tQc6k1ODezyaTOoCrSCWFcfCqQ"
				:data-domain="shopDomain"
				:data-product-id="product.id"
				:data-product-models="product.id"
				:data-name="product.title"
				:data-url="product.url"
				:data-image-url="product.featured_image"
				:data-description="product.description">
				<!-- data-bread-crumbs="{% for tag in product.tags %}{{ tag | escape }};{% endfor %}"> -->
			    </div>
                <div class="swatches">
                    <div class="swatch" v-for="swatch in product.swatches">
                        <div v-if="availableSwatch(swatch, product)" :style="'background-color:'+ swatch[1] +';'" :alt="swatch[0]" v-on:mouseover="switchImages(swatch[2], product)"><span>{{ swatch[0] }}</span></div>
                    </div>
                </div><!-- .swatches -->
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script src="./ctrl-home-featured-products-ab.js"></script>